import FormCorporateRepository from '../api/formCorporate';
import '../types';

class FormCorporateUseCase {
  constructor() {
    /** @type {FormCorporateRepository} */
    this.api = new FormCorporateRepository();
  }

  /**
     * @param payload {Object}
     * @param status {string}
     * @return {Promise <{data: formCorporate[], err: Error}}
     */

  async create(payload) {
    const { data, err } = await this.api.create(payload);
    return { data, err };
  }
}

export default new FormCorporateUseCase();
